<template>
    <BaseModal
        :id="'static-history-movement'"
        :title="`Room movement history of ${history_item.title}`"
        size="xl"
        :message="message !== undefined ? message : default_message"
        :link_event="link_event"
        :link_message="link_message"
        @linkEvent="linkEmitReceiver()"
    >
        <!-- :style_content="`height:0px; max-height:750px;`" -->
        <template v-slot:breadcrumb>
            <Breadcrumb :breadcrumb="breadcrumb"/>
        </template>
        <template v-slot:content>
            <div class="w-100 table-responsive defaultproject__table overflow-y--2" v-if="historial_movements.length">
                <table class="table">
                    <thead>
                        <tr>
                            <th v-for="(item, i) in history_table_headers" :key="i" scope="col" v-html="item.name"/>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="(item, i) in historial_movements" :key="i">
                            <td v-html="item.associate"/>
                            <td v-html="item.change_made_on"/>
                            <td v-html="item.room"/>
                            <td v-html="item.action"/>
                            <td v-html="item.to_assignment"/>
                        </tr>
                    </tbody>
                </table>
            </div>
        </template>
    </BaseModal>
</template>

<script>
import BaseModal    from '@/components/BaseModal'
import Breadcrumb   from '@/components/BreadcrumbComponent/Breadcrumb'

export default {

    name: 'HistoryMovementModal',

    props: [
        'notyf',
        'message',
        'rest_api',
        'breadcrumb',
        'history_item',
        'link_event',
        'link_message'
    ],

    data() {
        return {
            history_table_headers: [
                { 
                    name:   'Change made by',
                },
                {   
                    name:   'Change made on',
                },
                {
                    name:   'Room description',
                },
                {
                    name:   'Action',
                },
                {
                    name:   'Assignment',
                },
            ],

            historial_movements: [],
            default_message: `This record has a history of all the changes made to it since its creation. You can view each modification, including who made it and when it was made, by scrolling through the timeline below.`
        };
    },

    components: {
        BaseModal,
        Breadcrumb,
    },

    watch: {

        async 'history_item.id'(val)
        {
            this.historial_movements = []
            this.loader(true)

            let daily_assignment_id = val

            let json_request = {
                daily_assignment_id,
                movement_historial: true,
            }

            let route_api = `${this.rest_api}/${JSON.stringify(json_request)}`

            let response = await this.get(route_api)

            if(response.status)
            {
                this.historial_movements = response.data.historial_movements

                if(!this.historial_movements.length)
                {
                    this.notyf.error('Empty Room movement history')
                }
            }
            else
            {
                this.error_handling(response)
            }
        }

    },

    methods: {

        async historialRefresh()
        {
            if(this.history_item.id === undefined)
            {
                return false
            }
            
            this.historial_movements = []
            this.loader(true)

            let daily_assignment_id = this.history_item.id

            let json_request = {
                daily_assignment_id,
                movement_historial: true,
            }

            let route_api = `${this.rest_api}/${JSON.stringify(json_request)}`

            let response = await this.get(route_api)

            if(response.status)
            {
                this.historial_movements = response.data.historial_movements

                if(!this.historial_movements.length)
                {
                    this.notyf.error('Empty Room movement history')
                }
            }
            else
            {
                this.error_handling(response)
            }
        },

        linkEmitReceiver()
        {
            this.$emit('linkEventReceiver', true)
        },

    }
}
</script>